import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { Trans } from "react-i18next";
import { FORMAT_DATE_TIME_SHORTER } from "../../../common/dateFormats";
import { format } from "date-fns";

function ConfirmationModal({
  trainingUnit,
  willBeWaitingList,
  onConfirm,
  onClose
}) {
  return (
    <Modal open={true} size="tiny" onClose={onClose}>
      <Modal.Header>{trainingUnit.courseDate.course.title}</Modal.Header>
      <Modal.Content>
        {willBeWaitingList ? (
          <Trans
            i18nKey="coursePlan.registration.confirmation.waitingList"
            values={{
              courseName: trainingUnit.courseDate.course.title,
              courseDate: format(
                new Date(trainingUnit.date),
                FORMAT_DATE_TIME_SHORTER
              )
            }}
          />
        ) : (
          <Trans
            i18nKey="coursePlan.registration.confirmation.registration"
            values={{
              courseName: trainingUnit.courseDate.course.title,
              courseDate: format(
                new Date(trainingUnit.date),
                FORMAT_DATE_TIME_SHORTER
              )
            }}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button floated="left" onClick={onClose}>
          <Trans i18nKey="prompt.actions.no" />
        </Button>
        <Button primary onClick={onConfirm}>
          <Trans i18nKey="prompt.actions.yes" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

ConfirmationModal.displayName = "coursePlan/register/ConfirmationModal";

export default React.memo(ConfirmationModal);
